import actions from './actions';
import mutations from './mutations';
import getters from './getters';

const state = {
  invoice: {
    FolderDetails: {},
    CompanyDetails: {},
    services: [],
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
